/**
* Card Set One JS
* -----------------------------------------------------------------------------
*
* All the JS for the Card Set One component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'card-set-one',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let tallest = 0;

      const promise = new Promise( function() {
        $( '.card-set-one .get-height' ).each( function() {
          const thisHeight = this.clientHeight;
          if ( thisHeight > tallest ) {
            tallest = thisHeight;
          }
        } );
      } );

      promise.then( $( '.card-set-one .get-height' ).each( function() {
        this.style.height = tallest+'px';
      } )
      );

      gsap.registerPlugin( ScrollTrigger );
      $( '.yellow-border' ).each( function() {
        gsap.from( this, {
          scrollTrigger: {
            trigger: this,
            start: 'top 53%',
            scrub: false,
          },
          onStart: () => {
            this.classList.add( 'action' );
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'card-set-one', COMPONENT );
} )( app );
